import ImageHolder from "./imageHolder";
import parse from "html-react-parser";

function TextTemplate({ dataList }: { dataList: any[] }) {
  return (
    <section className="cht-max-w-7xl cht-mx-auto cht-px-4 sm:cht-px-6 lg:cht-px-8 cht-py-12 sm:cht-py-16 !cht-font-body">
      <div className="cht-space-y-16 sm:cht-space-y-20">
        {dataList.map((item, idx) => (
          <div
            key={item.id || idx}
            className="cht-grid lg:cht-grid-cols-12 cht-gap-8 lg:cht-gap-12 cht-items-center"
          >
            {/* Image Column */}
            <div
              className={`cht-w-full lg:cht-col-span-6 ${
                idx % 2 === 1 ? "lg:cht-order-2" : "lg:cht-order-1"
              }`}
            >
              <ImageHolder image={item.pic_url} />
            </div>

            {/* Text Column */}
            <div
              className={`cht-w-full lg:cht-col-span-6 ${
                idx % 2 === 1 ? "lg:cht-order-1" : "lg:cht-order-2"
              }`}
            >
              <h3 className="cht-text-2xl sm:cht-text-3xl cht-font-bold !cht-font-heading cht-text-[#1e293b] cht-tracking-tight cht-mb-4">
                {item.title}
              </h3>

              <div className="cht-text-slate-600 cht-leading-relaxed cht-prose cht-max-w-none">
                {parse(`${item.description}`)}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default TextTemplate;
